"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var useMediaContext_1 = require("../context/useMediaContext");

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? false : _ref$primary,
      href = _ref.href,
      onClick = _ref.onClick,
      className = _ref.className;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles;

  var ButtonComponent = href ? "a" : "button";
  return jsx_runtime_1.jsx(ButtonComponent, Object.assign({
    onClick: onClick,
    href: href,
    target: href ? "_blank" : undefined
  }, getStyles("button", className, {
    primary: primary
  }), {
    children: children
  }), void 0);
};

exports.Button = Button;